import { Check } from 'lucide-react'
import { Card, CardContent } from '@/components/ui/card'

export function RegistrationSuccess({ quantity }: { quantity: number }) {
  return (
    <Card className="h-fit">
      <CardContent className="space-y-2 px-4 py-6 text-center">
        <Check className="mx-auto h-5 w-5 text-primary" />
        <p className="text-body-sm font-medium">You’re registered</p>
        <p className="text-caption text-muted-foreground">
          {quantity} {quantity === 1 ? 'seat' : 'seats'} confirmed.
        </p>
      </CardContent>
    </Card>
  )
}
